import { displayDateTimeToMinute, Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { UserView } from './UserView';
import { Event } from './Event';
import { InstitutionGroup } from './InstitutionGroup';
import { PaymentIn } from './PaymentIn';
import { EVENTS_I_AM_ADMIN_OF } from './SecurityRules';
import { Ticket } from './Ticket';

export interface TicketBookingRow {
  id: number;
  user_id: string;
  event_id: number;
  event_date: string;
  ticket_id: number;
  payment_id: number | null;
  status: string;
  quantity: number;
  created_at: string;
  created_by: string;
  institution_group_id: number | null;
}

export const TicketBooking: Entity<TicketBookingRow> = {
  id: 'TicketBooking',
  title: 'TicketBooking',
  service: 'main',
  rowLabel: (row: TicketBookingRow) => String(row.event_id),
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.ticket_booking',
  },
  security: [
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `event_id IN ${EVENTS_I_AM_ADMIN_OF}`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  defaultSort: [['user_id', 'ASC']],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    user_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'User',
      mandatory: true,
      listColumn: true,
      refEntity: UserView,
    },
    event_id: {
      seq: 15,
      label: 'Event',
      type: FieldType.Reference,
      listColumn: true,
      refEntity: Event,
    },
    event_date: {
      seq: 20,
      type: FieldType.Date, // TODO: make this Datetime
      label: 'Starts At',
      listColumn: true,
      getDisplayText: (value: string) => displayDateTimeToMinute(value, '-'),
    },
    ticket_id: {
      seq: 30,
      label: 'Ticket',
      type: FieldType.Reference,
      listColumn: true,
      refEntity: Ticket,
    },
    payment_id: {
      seq: 32,
      label: 'Payment',
      type: FieldType.Reference,
      listColumn: true,
      refEntity: PaymentIn,
    },
    status: {
      seq: 35,
      label: 'Status',
      type: FieldType.Options,
      options: [
        { id: 'active', label: 'Active' },
        { id: 'canx-booking', label: 'Booking Cancelled' },
        { id: 'canx-event', label: 'Event Cancelled' },
      ],
    },
    quantity: {
      seq: 40,
      label: 'Quantity',
      type: FieldType.Integer,
      mandatory: true,
      listColumn: true,
    },
    created_at: {
      seq: 45,
      label: 'Created At',
      type: FieldType.Datetime,
      persistence: PersistenceType.BackEndManaged,
      listColumn: true,
    },
    created_by: {
      seq: 50,
      label: 'Created By',
      type: FieldType.Reference,
      refEntity: UserView,
    },
    institution_group_id: {
      seq: 55,
      label: 'Institution Group',
      type: FieldType.Reference,
      refEntity: InstitutionGroup,
    },
  },
};
